import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const t = e(["triggerContainer", "iconButton", "popoverBody"]), o = t.defineMultiStyleConfig({
  baseStyle: {
    triggerContainer: {
      width: "fit-content"
    },
    iconButton: {
      borderRadius: "full",
      display: "inline-block",
      height: "24px",
      verticalAlign: "inherit",
      fontSize: { base: "14px", md: "16px" },
      lineHeight: "0"
    },
    popoverBody: {
      _focusVisible: {
        outline: "none",
        boxShadow: "outline"
      }
    }
  }
});
export {
  o as default
};
